import * as React from 'react';
import {
    BlindsStructure,
    Level,
} from '../../../../generated/protocol';
import {
    Form,
    FormListener,
} from '../../form/Form';
import {
    FormSubmitError,
    FormSubmitSuccess,
} from '../../form/FormFeedback';
import { Submit } from '../../form/Submit';
import { FormGroup } from '../../form/FormGroup';
import { FormInput } from '../../form/FormInput';
import { Validators } from '../../form/Validators';
import {
    BindModel,
    FormList,
    ListItemBinding,
} from '../../form/FormList';

interface Props {
    structure?: BlindsStructure;
    validationMap?: any;
    formListener?: FormListener<BlindsStructure>;
    onSuccessClose?: () => void;
    addItemAfter?: (index) => void;
    removeItem?: (index) => void;
}

export class BlindsStructureForm extends React.Component<Props, {}> {

    render() {
        return (
            <Form className='form-horizontal' formListener={this.props.formListener} modelObject={this.props.structure}
                  validationMap={this.props.validationMap}>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className='ibox float-e-margins'>
                            <div className='ibox-title'>
                                <h5>Blinds Info</h5>
                            </div>
                            <div className='ibox-content'>
                                <div className='hr-line-dashed'/>
                                <FormGroup className='form-group' model='name'>
                                    <label className='col-sm-2 control-label '>Name</label>
                                    <div className='col-sm-10'>
                                        <FormInput model='name' type='text' className='form-control name'
                                                   validators={[Validators.required()]}/>
                                    </div>
                                </FormGroup>
                                <div className='hr-line-dashed'/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-lg-12'>
                        <div className='ibox float-e-margins'>
                            <div className='ibox-title'>
                                <h5>Blinds Levels</h5>
                            </div>
                            <div className='ibox-content'>
                                <div className='row'>
                                    <div className='col-sm-1'/>
                                    <div className='col-sm-1'/>
                                    <div className='col-sm-2'>
                                        Ante
                                    </div>
                                    <div className='col-sm-2'>
                                        Small Blind
                                    </div>
                                    <div className='col-sm-2'>
                                        Big Blind
                                    </div>
                                    <div className='col-sm-1'>
                                        Duration
                                    </div>
                                    <div className='col-sm-1'>
                                        Break
                                    </div>
                                </div>
                                <div className='hr-line-dashed'/>
                                <FormList model='blindsLevels'>
                                    <div className='row'>
                                        <div className='col-sm-1'>
                                            <BindModel type='list-item' render={(m: ListItemBinding<Level>) => {
                                                return <button tabIndex={-1} className='btn btn-default btn-circle'
                                                               type='button' onClick={() => m.moveItem(true)}><i
                                                    className='fa fa-angle-up'/></button>
                                            }}/>

                                            <BindModel type='list-item' render={(m: ListItemBinding<Level>) => {
                                                return <button tabIndex={-1} className='btn btn-default btn-circle'
                                                               type='button' onClick={() => m.moveItem(false)}><i
                                                    className='fa fa-angle-down'/></button>
                                            }}/>
                                        </div>
                                        <div className='col-sm-1'>
                                            <BindModel type='list-item' validators={[Validators.required()]}
                                                       render={(m: ListItemBinding<Level>) =>
                                                           <div>{m.index + 1}</div>}/>
                                        </div>
                                        <div className='col-sm-2'>
                                            <FormInput className='form-control' validators={[Validators.required()]}
                                                       type='float' model='anteAmount' placeholder='Ante'/>
                                        </div>
                                        <div className='col-sm-2'>
                                            <FormInput className='form-control' validators={[Validators.required()]}
                                                       type='float' model='smallBlindAmount' placeholder='Small Blind'/>
                                        </div>
                                        <div className='col-sm-2'>
                                            <FormInput className='form-control' validators={[Validators.required()]}
                                                       type='float' model='bigBlindAmount' placeholder='Big Blind'/>
                                        </div>
                                        <div className='col-sm-1'>
                                            <FormInput className='form-control' validators={[Validators.required()]}
                                                       type='integer' model='durationInMinutes' placeholder='Duration'/>
                                        </div>
                                        <div className='col-sm-1'>
                                            <FormInput type='checkbox' model='break'/>
                                        </div>
                                        <div className='col-sm-1'>
                                            <BindModel type='list-item' render={(m: ListItemBinding<Level>) => {
                                                return <button tabIndex={-1}
                                                               className='btn btn-default btn-circle pull-right'
                                                               onClick={(() => this.props.addItemAfter(m.index))}
                                                               type='button'><i className='fa fa-plus'/></button>
                                            }}/>
                                        </div>
                                        <div className='col-sm-1'>
                                            <BindModel type='list-item' render={(m: ListItemBinding<Level>) => {
                                                return <button tabIndex={-1}
                                                               className='btn btn-danger btn-circle pull-right'
                                                               onClick={(() => this.props.removeItem(m.index))}
                                                               type='button'><i className='fa fa-times'/></button>
                                            }}/>
                                        </div>
                                    </div>
                                    <div className='hr-line-dashed' style={{margin: '15px 0'}}/>
                                </FormList>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-lg-12'>
                        <div className='ibox float-e-margins'>
                            <div className='ibox-content'>
                                <div className='ibox-title'>
                                    <h5>Actions</h5>
                                </div>
                                <FormSubmitError/>
                                <FormSubmitSuccess text='Tournament was updated successfully'
                                                   onClose={() => this.props.onSuccessClose()}/>
                                <div className='form-group'>
                                    <div className='col-sm-10 col-sm-offset-2'>
                                        <Submit className='ladda-button btn-lg btn-primary'>Save Blinds
                                            Structure</Submit>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/BlindsStructureForm.tsx